<p-dialog
  [modal]="true"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
>
  <ng-template #headless>
    <div class="min-h-[260px] xlplus:min-h-[300px] w-[500px] xlplus:w-[480px] p-[28px] rounded-2xl bg-white">
      <div>
        <h3 class="font-inter font-semibold text-[22px] xlplus:text-2xl">
          {{ title }}
        </h3>
      </div>
      <div class="mt-[24px]">
        <div class="text-sm xlplus:text-base">
          <div class="flex flex-col gap-4 mt-[24px]" *ngFor="let paragraph of bodyParagraphs">
            <div class="flex flex-row gap-2 2xl:gap-[20px]">
              <div>
                {{ paragraph }}
              </div>
            </div>
          </div>
          <div class="flex gap-1 justify-end mt-[16px]">
            <p-button
              [label]="backLabel"
              variant="outlined"
              styleClass="!w-[80px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !mr-2 !text-sm xlplus:!text-base !min-w-[89px] hover:!bg-[#E0F2FE]"
              (onClick)="onBackClick()"
            >
            </p-button>
            <p-button
              [label]="convertLabel"
              type="button"
              styleClass="!min-w-[80px] xlplus:!min-w-[100px] !text-sm xlplus:!text-base !bg-taxpod-blue !border-taxpod-blue !font-lato !font-bold disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
              (onClick)="onConvertClick()"
            >
            </p-button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
